export default "__VITE_ASSET__$N_MQSsZ__"